import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import ResponsiveBreakpointsRolloutBoundary from 'components/ResponsiveBreakpointsRolloutBoundary'
import { RESPONSIVE_BREAKPOINT_PAGES } from 'constants/responsiveBreakpoints'

const PlaylistWithRollout = ({ children }) => {
  const { t } = useTranslation()

  return (
    <ResponsiveBreakpointsRolloutBoundary
      fallback={
        <div className="p-8 text-white" aria-live="polite" role="status">
          {t('general.loading')}
        </div>
      }
      page={RESPONSIVE_BREAKPOINT_PAGES.PLAYLIST}
    >
      {children}
    </ResponsiveBreakpointsRolloutBoundary>
  )
}

PlaylistWithRollout.propTypes = {
  children: PropTypes.node.isRequired
}

export default PlaylistWithRollout
